<template>
  <div>
    <!-- CASH BALANCE -->
    <b-row class="mb-1 d-flex align-items-center">
      <b-col cols="2" class="font-weight-bold d-flex flex-column">
        <span>Cash Balance</span>
        <span style="font-size: 16px">{{
          formatCurrencyBuiltInFunc(form.cashBalance)
        }}</span>
      </b-col>
      <b-col cols="2">
        <div>Add</div>
        <b-form-input
          id="deposit-value"
          v-model="cashBalance.amountAdd"
          :disabled="!!cashBalance.amountDeduct"
          :no-wheel="true"
        />
      </b-col>
      <b-col cols="2">
        <div>Deduct</div>
        <b-form-input
          id="deposit-value"
          v-model="cashBalance.amountDeduct"
          :disabled="!!cashBalance.amountAdd"
          :no-wheel="true"
        />
      </b-col>

      <b-col cols="2">
        <b-button
          variant="primary"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :disabled="cashBalance.loadingChangeBalance"
          class="btn-set mt-2"
          @click="showModal('update-cash')"
        >
          Apply
        </b-button>
      </b-col>
    </b-row>

    <!-- WITHDRAWABLE BALANCE -->
    <b-row class="mb-1 d-flex align-items-center">
      <b-col cols="2" class="font-weight-bold d-flex flex-column">
        <span>Withdrawable Balance</span>
        <span style="font-size: 16px">{{
          formatCurrencyBuiltInFunc(form.maximumWithdrawalValue)
        }}</span>
      </b-col>
      <b-col cols="2">
        <div>Add</div>
        <b-form-input
          id="deposit-value"
          v-model="withdrawableBalance.amountAdd"
          :disabled="!!withdrawableBalance.amountDeduct"
          :no-wheel="true"
        />
      </b-col>
      <b-col cols="2">
        <div>Deduct</div>
        <b-form-input
          id="deposit-value"
          v-model="withdrawableBalance.amountDeduct"
          :disabled="!!withdrawableBalance.amountAdd"
          :no-wheel="true"
        />
      </b-col>

      <b-col cols="2">
        <b-button
          variant="primary"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :disabled="withdrawableBalance.loadingChangeBalance"
          class="btn-set mt-2"
          @click="showModal('update-withdrawable')"
        >
          Apply
        </b-button>
      </b-col>
    </b-row>

    <b-card no-body>
      <h4
        class="font-weight-bold p-1 m-0"
        style="border-bottom: 1px solid #e5e7eb"
      >
        Customer Information
      </h4>
      <b-card-body class="px-1">
        <validation-observer ref="generalUserForm">
          <b-container class="bv-example-row">
            <!-- USER DETAIL -->
            <b-row>
              <b-col cols="12">
                <validation-observer ref="validateUserDetail">
                  <b-form>
                    <b-row class="mb-1 d-flex align-items-stretch">
                      <!-- <b-col cols="12" md="3">
                        <label class="font-weight-bold">Account Status</label>
                        <v-select
                          :value="form.status"
                          :options="statuses"
                          :clearable="false"
                          :reduce="(val) => val.value"
                          @input="(val) => (form.status = val)"
                        />
                      </b-col>
                      <b-col cols="12" md="3">
                        <label class="font-weight-bold">BDM Manager</label>
                        <v-select
                          :value="form.role"
                          :options="roles"
                          :clearable="false"
                          :reduce="(val) => val.value"
                          @input="(val) => (form.role = val)"
                        />
                      </b-col> -->
                      <b-col cols="12" md="3">
                        <label class="font-weight-bold">Profile Type</label>
                        <v-select
                          :value="form.profile"
                          :options="profiles"
                          :clearable="false"
                          :reduce="(val) => val.value"
                          @input="(val) => (form.profile = val)"
                        />
                      </b-col>
                    </b-row>

                    <b-row class="mb-1 d-flex align-items-stretch">
                      <b-col cols="12" md="4">
                        <label class="font-weight-bold">First Name *</label>
                        <validation-provider
                          #default="{ errors }"
                          name="first name"
                          rules="required|name"
                        >
                          <b-form-input v-model="form.firstName" type="text" />

                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="4">
                        <validation-provider
                          #default="{ errors }"
                          name="last name"
                          rules="required|name"
                        >
                          <label class="font-weight-bold">Last Name *</label>
                          <b-form-input v-model="form.lastName" type="text" />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="4">
                        <label class="font-weight-bold">Gender</label>
                        <v-select
                          :value="form.gender"
                          :options="genders"
                          :clearable="false"
                          :reduce="(val) => val.value"
                          @input="(val) => (form.gender = val)"
                        />
                      </b-col>
                    </b-row>

                    <b-row class="mb-1 d-flex align-items-stretch">
                      <b-col cols="12" md="3">
                        <validation-provider
                          #default="{ errors }"
                          name="email"
                          rules="required|email"
                        >
                          <label class="font-weight-bold"
                            >Email Address *</label
                          >
                          <b-form-input v-model="form.email" type="text" />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="3">
                        <validation-provider
                          #default="{ errors }"
                          name="phone number"
                        >
                          <label class="font-weight-bold"
                            >Mobile Number *</label
                          >
                          <b-form-input v-model="form.phoneNumber" type="tel" />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="3">
                        <validation-provider
                          #default="{ errors }"
                          name="username"
                          rules="required"
                        >
                          <label class="font-weight-bold">Username *</label>
                          <b-form-input v-model="form.username" type="text" />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>

                      <b-col cols="12" md="3">
                        <label class="font-weight-bold">Password</label>
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            v-model="form.password"
                            :type="showPassword ? 'text' : 'password'"
                            name="new-password"
                            placeholder="New Password"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                              class="cursor-pointer"
                              @click="showPassword = !showPassword"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-muted"
                          >Leave blank to keep current password</small
                        >
                      </b-col>
                    </b-row>

                    <b-row class="mb-1 d-flex align-items-stretch">
                      <b-col cols="12" md="3">
                        <validation-provider #default="{ errors }">
                          <label class="font-weight-bold"
                            >Registration Date</label
                          >
                          <flat-pickr
                            v-model="form.registerDate"
                            class="form-control"
                            :config="configDate"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </b-form></validation-observer
                >
              </b-col>
              <b-col cols="12">
                <!-- Action Buttons -->
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="showModal(UserAction.SET_CLIENT_PROFILE)"
                >
                  <template> Save changes </template>
                </b-button>
                <b-button
                  variant="outline-secondary"
                  type="reset"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click.prevent="resetForm"
                >
                  Reset
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </validation-observer>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <h4 class="font-weight-bold p-1" style="border-bottom: 1px solid #e5e7eb">
        Responsible Gambling
      </h4>
      <b-card-body>
        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="12">
              <b-row class="mb-1 d-flex align-items-start">
                <!-- <b-col cols="12" md="4"> </b-col> -->
                <b-col cols="12" md="6">
                  <div
                    class="d-flex align-items-center"
                    style="gap: 10px; margin-bottom: 6px"
                  >
                    <label class="font-weight-bold">Daily Betting Limit</label>
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        v-model="bettingLimits.daily.isNoLimit"
                      />
                      <span>No Limit</span>
                    </div>
                  </div>

                  <b-input-group size="md" prepend="$">
                    <b-form-input
                      v-model="bettingLimits.daily.amount"
                      :disabled="bettingLimits.daily.isNoLimit"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col cols="12" md="6">
                  <div
                    class="d-flex align-items-center"
                    style="gap: 10px; margin-bottom: 6px"
                  >
                    <label class="font-weight-bold">Weekly Betting Limit</label>
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        v-model="bettingLimits.weekly.isNoLimit"
                      />
                      <span>No Limit</span>
                    </div>
                  </div>
                  <b-input-group size="md" prepend="$">
                    <b-form-input
                      v-model="bettingLimits.weekly.amount"
                      :disabled="bettingLimits.weekly.isNoLimit"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row class="mb-1 d-flex align-items-stretch">
                <b-col cols="12">
                  <b-row>
                    <b-col cols="12" md="6">
                      <div
                        class="d-flex align-items-center"
                        style="gap: 10px; margin-bottom: 6px"
                      >
                        <label class="font-weight-bold"
                          >Fortnightly Betting Limit</label
                        >
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="bettingLimits.fortnightly.isNoLimit"
                          />
                          <span>No Limit</span>
                        </div>
                      </div>
                      <b-input-group size="md" prepend="$">
                        <b-form-input
                          v-model="bettingLimits.fortnightly.amount"
                          :disabled="bettingLimits.fortnightly.isNoLimit"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div
                        class="d-flex align-items-center"
                        style="gap: 10px; margin-bottom: 6px"
                      >
                        <label class="font-weight-bold"
                          >Monthly Betting Limit</label
                        >
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="bettingLimits.monthly.isNoLimit"
                          />
                          <span>No Limit</span>
                        </div>
                      </div>
                      <b-input-group size="md" prepend="$">
                        <b-form-input
                          v-model="bettingLimits.monthly.amount"
                          :disabled="bettingLimits.monthly.isNoLimit"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col class="d-flex justify-content-end mt-1">
                      <b-button
                        size="md"
                        class="d-flex align-items-center justify-content-center mr-2"
                        @click="handleResetLimit"
                      >
                        <span class="ml-1 text-lg">Cancel</span>
                      </b-button>
                      <b-button
                        size="md"
                        variant="primary"
                        class="d-flex align-items-center justify-content-center"
                        @click="showModal('bet-limit')"
                      >
                        <feather-icon size="20" icon="SaveIcon" />
                        <span class="ml-1 text-lg text-white"
                          >Save changes</span
                        >
                      </b-button>
                    </b-col>
                  </b-row>

                  <div class="mt-2 mb-2"><DepositLimitHistories /></div>

                  <BreakHistories />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <h4 class="font-weight-bold p-1" style="border-bottom: 1px solid #e5e7eb">
        Advance Settings
      </h4>
      <b-card-body>
        <validation-observer ref="validateAdvance">
          <b-container class="bv-example-row">
            <b-row class="mb-1">
              <b-col cols="12" md="4" class="mb-1">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <b-form-checkbox v-model="advance.allowCashOut" switch />
                  <label class="font-weight-bold mb-0">Allow Cash Out</label>
                </div>
              </b-col>
              <b-col cols="12" md="4" class="mb-1">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <b-form-checkbox v-model="advance.allowSGM" switch />
                  <label class="font-weight-bold mb-0">Allow SGM</label>
                </div>
              </b-col>
              <b-col cols="12" md="4" class="mb-1">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <b-form-checkbox v-model="advance.allowFuture" switch />
                  <label class="font-weight-bold mb-0">Allow Future</label>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <label class="font-weight-bold">Bonus Cash for Deposit</label>
                <validation-provider
                  #default="{ errors }"
                  name="bonus cash for deposit"
                  rules="between:0,999.99"
                >
                  <b-form-input
                    :value="advance.numberOfBonusCashForDeposit"
                    type="number"
                    @input="
                      advance.numberOfBonusCashForDeposit =
                        limitTwoDecimals($event)
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <label class="font-weight-bold">Bonus Cash for Stake</label>
                <validation-provider
                  #default="{ errors }"
                  name="bonus cash for stake"
                  rules="between:0,999.99"
                >
                  <b-form-input
                    :value="advance.numberOfBonusCashForStake"
                    type="number"
                    @input="
                      advance.numberOfBonusCashForStake =
                        limitTwoDecimals($event)
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-end mt-1">
                <b-button
                  size="md"
                  variant="primary"
                  class="d-flex align-items-center justify-content-center"
                  @click="showModal('update-advance')"
                >
                  <feather-icon size="20" icon="SaveIcon" />
                  <span class="ml-1 text-lg text-white">Save changes</span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </validation-observer>
      </b-card-body>
    </b-card>

    <PromoConfigSettings :userData="userData" />

    <!-- <b-card no-body>
      <h4 class="font-weight-bold p-1" style="border-bottom: 1px solid #e5e7eb">
        Verification Settings
      </h4>
      <b-card-body>
        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="12">
              <b-row class="mb-1 d-flex align-items-start">
                <b-col cols="12" md="4">
                  <label class="font-weight-bold">ID Verification Status</label>
                  <v-select
                    :value="selected.verifyId"
                    :options="options.verifyId"
                    :clearable="false"
                    :reduce="(val) => val.value"
                    @input="(val) => (selected.verifyId = val)"
                  />
                </b-col>
                <b-col cols="12" md="4">
                  <label class="font-weight-bold"
                    >Address Verification Status</label
                  >
                  <v-select
                    :value="selected.addressVerify"
                    :options="options.addressVerify"
                    :clearable="false"
                    :reduce="(val) => val.value"
                    @input="(val) => (selected.addressVerify = val)"
                  />
                </b-col>
                <b-col cols="12" md="4">
                  <label class="font-weight-bold">
                    Payment Method Verification
                  </label>
                  <v-select
                    :value="selected.paymentMethodVerify"
                    :options="options.paymentMethodVerify"
                    :clearable="false"
                    :reduce="(val) => val.value"
                    @input="(val) => (selected.paymentMethodVerify = val)"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p class="font-weight-bold text-body">Verification Documents</p>
            </b-col>
            <b-col cols="12" md="4">
              <b-col cols="12" class="border rounded p-1">
                <b-row
                  class="d-flex align-items-center justify-content-between"
                >
                  <b-col
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="font-weight-bold text-body mb-0 text-nowrap">
                      Driver's License
                    </p>
                    <div
                      class="rounded-lg d-flex align-items-center justify-content-center"
                      style="
                        background: #cce7d0;
                        border: 1px solid #e9f6ec;
                        padding: 2px 4px;
                        height: fit-content;
                        width: fit-content;
                      "
                    >
                      <p
                        class="mb-0 text-right"
                        style="color: #37b260; font-size: 12px"
                      >
                        Verified
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    ><p class="font-weight-bold text-body mb-0">
                      Uploaded: Jan 15, 2025
                    </p></b-col
                  >
                </b-row>
                <b-row class="d-flex align-items-center">
                  <b-col cols="12" class="d-flex align-items-center">
                    <feather-icon
                      icon="EyeIcon"
                      size="14"
                      class="text-primary"
                    />
                    <p class="text-primary mb-0 mr-1">View</p>
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="text-muted"
                    />
                    <p class="text-muted mb-0">Download</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>

            <b-col cols="12" md="4">
              <b-col cols="12" class="border rounded p-1">
                <b-row
                  class="d-flex align-items-center justify-content-between"
                >
                  <b-col
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="font-weight-bold text-body mb-0 text-nowrap">
                      Utility Bill
                    </p>
                    <div
                      class="rounded-lg d-flex align-items-center justify-content-center"
                      style="
                        background: #cce7d0;
                        border: 1px solid #e9f6ec;
                        padding: 2px 4px;
                        height: fit-content;
                        width: fit-content;
                      "
                    >
                      <p
                        class="mb-0 text-right"
                        style="color: #37b260; font-size: 12px"
                      >
                        Verified
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    ><p class="font-weight-bold text-body mb-0">
                      Uploaded: Jan 15, 2025
                    </p></b-col
                  >
                </b-row>
                <b-row class="d-flex align-items-center">
                  <b-col cols="12" class="d-flex align-items-center">
                    <feather-icon
                      icon="EyeIcon"
                      size="14"
                      class="text-primary"
                    />
                    <p class="text-primary mb-0 mr-1">View</p>
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="text-muted"
                    />
                    <p class="text-muted mb-0">Download</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>

            <b-col cols="12" md="4">
              <b-col cols="12" class="border rounded p-1">
                <b-row
                  class="d-flex align-items-center justify-content-between"
                >
                  <b-col
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="font-weight-bold text-body mb-0 text-nowrap">
                      Bank Statement
                    </p>
                    <div
                      class="rounded-lg d-flex align-items-center justify-content-center"
                      style="
                        background: #cce7d0;
                        border: 1px solid #e9f6ec;
                        padding: 2px 4px;
                        height: fit-content;
                        width: fit-content;
                      "
                    >
                      <p
                        class="mb-0 text-right"
                        style="color: #37b260; font-size: 12px"
                      >
                        Verified
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    ><p class="font-weight-bold text-body mb-0">
                      Uploaded: Jan 15, 2025
                    </p></b-col
                  >
                </b-row>
                <b-row class="d-flex align-items-center">
                  <b-col cols="12" class="d-flex align-items-center">
                    <feather-icon
                      icon="EyeIcon"
                      size="14"
                      class="text-primary"
                    />
                    <p class="text-primary mb-0 mr-1">View</p>
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="text-muted"
                    />
                    <p class="text-muted mb-0">Download</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>

            <b-col class="mt-1">
              <b-button
                size="md"
                variant="light"
                class="d-flex align-items-center justify-content-center"
              >
                <feather-icon size="20" icon="UploadIcon" />
                <span class="ml-1 text-lg">Upload New Document</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card> -->

    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isLoading"
      @ok="handleSubmitModal"
    >
      <b-card-text class="text-black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isLoading" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { objectProp } from "@/helpers/props";
import Spinner from "@core/components/Spinner";
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BContainer,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BMedia,
  BRow,
  BTable,
  VBModal,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapActions, mapState } from "vuex";
import { UserAction } from "@core/utils/enum/user";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { formatAuPhone } from "@/helpers/phone";
import useToastHandler from "@/services/toastHandler";
import { between } from "@validations";
import BreakHistories from "./components/BreakHistories.vue";
import DepositLimitHistories from "./components/DepositLimitHistories.vue";
import PromoConfigSettings from "./components/PromoConfigSettings.vue";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    Spinner,
    ValidationProvider,
    BContainer,
    BFormCheckbox,
    BCardText,
    BFormSelect,
    flatPickr,
    ValidationObserver,
    BForm,
    BFormTextarea,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    BTable,
    BCardBody,
    BInputGroup,
    BFormGroup,
    BMedia,
    BreakHistories,
    DepositLimitHistories,
    PromoConfigSettings,
  },
  watch: {
    profileTypes(newVal) {
      this.profiles = newVal.map((type) => ({
        value: type.profileTypeId,
        label: type.profileTypeId,
      }));
    },
  },

  directives: {
    "b-modal": VBModal,
  },
  UserDetailes: {
    Ripple,
  },
  props: {
    userData: objectProp(),
  },
  created() {
    if (this.userData) {
      this.resetForm();
      this.getProfileTypes();
      this.convertBetLimit();
    }
  },
  data() {
    return {
      UserAction,
      form: {
        cashBalance: 0,
        bonusBalance: 0,
        status: "Open",
        profile: "",
        role: "",
        firstName: "",
        lastName: "",
        gender: "",
        email: "",
        registerDate: "",
        username: "",
        phoneNumber: "",
        password: "",
        maximumWithdrawalValue: 0,
      },
      cashBalance: {
        amountAdd: null,
        amountDeduct: null,
      },
      withdrawableBalance: {
        amountAdd: null,
        amountDeduct: null,
      },
      selected: {
        verifyId: "Verified",
        addressVerify: "Verified",
        paymentMethodVerify: "Verified",
      },
      options: {
        verifyId: [{ value: "verified", label: "Verified" }],
        addressVerify: [{ value: "verified", label: "Verified" }],
        paymentMethodVerify: [{ value: "verified", label: "Verified" }],
      },
      statuses: [
        { value: "open", label: "Open" },
        { value: "blocked", label: "Blocked" },
        { value: "closed", label: "Closed" },
      ],
      roles: [
        { value: "SA", label: "Super Admin" },
        { value: "CM", label: "Customer Manager" },
        { value: "MS", label: "Marketing Specialist" },
        { value: "SP", label: "Support Agent" },
      ],
      genders: [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
      ],
      profiles: [],
      password: "",
      sortBy: "id",
      sortDesc: false,
      isChangePassword: "false",

      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
      configDate: {
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      showPassword: false,

      advance: {
        allowCashOut: false,
        allowSGM: false,
        allowFuture: false,
        numberOfBonusCashForDeposit: null,
        numberOfBonusCashForStake: null,
      },
      advanceInitial: null, // snapshot for dirty-tracking

      bettingLimits: {
        daily: {
          amount: null,
          period: 1,
          isNoLimit: false, // active, inactive
        },
        weekly: {
          amount: null,
          period: 7,
          isNoLimit: false, // active, inactive
        },
        fortnightly: {
          amount: null,
          period: 14,
          isNoLimit: false, // active, inactive
        },
        monthly: {
          amount: null,
          period: 30,
          isNoLimit: false, // active, inactive
        },
      },
    };
  },

  computed: {
    ...mapState("user/update", ["error"]),
    ...mapState("user/detail", [
      "loadingClientProfile",
      "loadingAddBalance",
      "loadingUserAdvance",
      "profileTypes",
    ]),
    ...mapState("user/bonus", ["loadingBetLimit"]),
    isLoading() {
      return (
        this.loadingClientProfile ||
        this.loadingAddBalance ||
        this.loadingUserAdvance
      );
    },
  },

  methods: {
    ...mapActions("user/detail", [
      "updateClientProfile",
      "resetPassword",
      "updateUserBalance",
      "asyncUser",
      "updateUserWithdrawal",
      "getProfileTypes",
      "changePasswordUser",
      "updateUserAdvance",
    ]),
    ...mapActions("user/bonus", ["setBetLimit"]),
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    async showModal(type, val) {
      this.action = { type };
      if (type === UserAction.SET_CLIENT_PROFILE) {
        const valid = await this.$refs.validateUserDetail.validate();
        if (!valid) return;
        this.setModal(
          "Set Client Profile",
          "Are you sure you want to update new profile for this user?"
        );
      }
      if (type === "update-cash") {
        if (!this.cashBalance.amountAdd && !this.cashBalance.amountDeduct)
          return;
        if (
          this.cashBalance.amountDeduct > this.userData.user.balance &&
          !this.cashBalance.amountAdd
        ) {
          this.showToastError(
            "The balance is lower than the deduct amount",
            "Error"
          );
          this.cashBalance.amountDeduct = null;
          return;
        }
        this.setModal(
          `${this.cashBalance.amountDeduct ? "Deduct" : "Add"} Cash Balance`,
          `Are you sure you want to ${
            this.cashBalance.amountDeduct ? "minus" : "add"
          } $${
            this.cashBalance.amountAdd || this.cashBalance.amountDeduct
          } for this user?`
        );
      }

      if (type === "update-withdrawable") {
        if (
          !this.withdrawableBalance.amountAdd &&
          !this.withdrawableBalance.amountDeduct
        )
          return;
        if (
          this.withdrawableBalance.amountDeduct >
            this.userData.user.maximumWithdrawalValue &&
          !this.withdrawableBalance.amountAdd
        ) {
          this.showToastError(
            "The withdrawable amount is lower than the deduct amount",
            "Error"
          );
          this.withdrawableBalance.amountDeduct = null;
          return;
        }
        this.setModal(
          `${
            this.withdrawableBalance.amountDeduct ? "Deduct" : "Add"
          } Withdrawable`,
          `Are you sure you want to ${
            this.withdrawableBalance.amountDeduct ? "minus" : "add"
          } $${
            this.withdrawableBalance.amountAdd ||
            this.withdrawableBalance.amountDeduct
          } for this user?`
        );
      }

      if (type === "bet-limit") {
        this.setModal(
          `Betting Limit`,
          `Are you sure you want to save new betting limit for this user?`
        );
      }

      if (type === "update-advance") {
        const valid = await this.$refs.validateAdvance.validate();
        if (!valid) return;
        if (!Object.keys(this.buildAdvancePayload()).length) return; // no change → no-op
        this.setModal(
          "Advance Settings",
          "Are you sure you want to update advance settings for this user?"
        );
      }

      this.$refs.modal.show();
    },
    resetForm() {
      this.form = {
        cashBalance: this.userData.user.balance || 0,
        bonusBalance: 0,
        status: this.userData.user.isActive
          ? "Open"
          : this.userData.user.isBlocked
          ? "Blocked"
          : "Closed",
        profile: this.userData.user.profile || "",
        // role: this.userData.user.roles[0].name || "",
        firstName: this.userData.user.firstName || "",
        lastName: this.userData.user.lastName || "",
        gender: this.userData.user.gender || "",
        email: this.userData.user.email || "",
        registerDate: this.userData.user.createdTime || "",
        username: this.userData.user.username || "",
        phoneNumber: this.userData.user.phoneNumber || "",
        password: "",
      };
      // forward-compatible prefill: works once GET returns these fields
      const u = this.userData.user;
      this.advance = {
        allowCashOut: u.allowCashOut ?? false,
        allowSGM: u.allowSGM ?? false,
        allowFuture: u.allowFuture ?? false,
        numberOfBonusCashForDeposit: u.numberOfBonusCashForDeposit ?? null,
        numberOfBonusCashForStake: u.numberOfBonusCashForStake ?? null,
      };
      this.advanceInitial = { ...this.advance };
    },
    handleHideModal() {
      this.password = null;
      this.passwordConfirm = "password";
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type } = this.action;
      if (type === UserAction.SET_CLIENT_PROFILE)
        await this.handleUpdateProfile();
      if (type === "update-cash") await this.handleUpdateCash();
      if (type === "update-withdrawable") await this.handleUpdateWithdrawable();
      if (type === "bet-limit") {
        await this.handleSaveNewBetLimit();
      }
      if (type === "update-advance") await this.handleUpdateAdvance();
      this.$refs.modal.hide();
    },
    limitTwoDecimals(value) {
      if (value === "" || value === null || value === undefined) return null;
      const str = String(value);
      if (str.includes(".")) {
        const [intPart, decPart] = str.split(".");
        if (decPart.length > 2) return `${intPart}.${decPart.slice(0, 2)}`;
      }
      return value;
    },
    buildAdvancePayload() {
      const init = this.advanceInitial || {};
      const out = {};
      [
        "allowCashOut",
        "allowSGM",
        "allowFuture",
      ].forEach((k) => {
        if (this.advance[k] !== init[k]) out[k] = this.advance[k];
      });
      ["numberOfBonusCashForDeposit", "numberOfBonusCashForStake"].forEach(
        (k) => {
          const v = this.advance[k];
          if (v !== "" && v !== null && Number(v) !== init[k])
            out[k] = Number(v);
        }
      );
      return out;
    },
    async handleUpdateAdvance() {
      const res = await this.updateUserAdvance({
        userId: this.$route.params.id,
        ...this.buildAdvancePayload(),
      });
      if (res) {
        this.showToastSuccess(
          "Success",
          "Update advance settings successfully"
        );
        await this.asyncUser({ id: this.$route.params.id });
        this.advanceInitial = { ...this.advance };
      }
    },
    async handleUpdateProfile() {
      const { password, ...restForm } = this.form;
      const res = await this.updateClientProfile({
        userId: this.$route.params.id,
        ...restForm,
        phoneNumber: formatAuPhone(this.form.phoneNumber),
        isActive: this.form.status === "open" ? 1 : undefined,
        isBlocked: this.form.status === "blocked" ? 1 : undefined,
        isBaned: this.form.status === "closed" ? 1 : undefined,
      });
      if (this.form.password) {
        await this.changePasswordUser({
          userId: this.$route.params.id,
          password: this.form.password,
        });
      }
      if (res) {
        this.showToastSuccess("Success", "Update profile successfully");
      }
    },
    async handleUpdateCash() {
      const res = await this.updateUserBalance({
        id: this.$router.currentRoute.params.id,
        amount: this.cashBalance.amountAdd || -+this.cashBalance.amountDeduct,
      });
      if (res) {
        if (this.cashBalance.amountAdd)
          this.form.cashBalance =
            Number(this.form.cashBalance) + Number(this.cashBalance.amountAdd);
        if (this.cashBalance.amountDeduct)
          this.form.cashBalance =
            Number(this.form.cashBalance) +
            -Number(this.cashBalance.amountDeduct);
        this.showToastSuccess(
          "Success",
          `${
            this.cashBalance.amountAdd ? "Add" : "Deduct"
          } Balance Successfully`
        );
        this.cashBalance.amountAdd = null;
        this.cashBalance.amountDeduct = null;
      }

      return res;
    },
    async handleUpdateWithdrawable() {
      const res = await this.updateUserWithdrawal({
        id: this.$router.currentRoute.params.id,
        amount:
          this.withdrawableBalance.amountAdd ||
          -+this.withdrawableBalance.amountDeduct,
      });
      if (res) {
        if (this.withdrawableBalance.amountAdd)
          this.form.maximumWithdrawalValue =
            Number(this.form.maximumWithdrawalValue) +
            Number(this.withdrawableBalance.amountAdd);
        if (this.withdrawableBalance.amountDeduct)
          this.form.maximumWithdrawalValue =
            Number(this.form.maximumWithdrawalValue) +
            -Number(this.withdrawableBalance.amountDeduct);
        this.showToastSuccess(
          "Success",
          `${
            this.withdrawableBalance.amountAdd ? "Add" : "Deduct"
          } Withdrawable Successfully`
        );
        this.withdrawableBalance.amountAdd = null;
        this.withdrawableBalance.amountDeduct = null;
      }
      return res;
    },
    async handleSaveNewBetLimit() {
      const res = await Promise.all([
        this.setBetLimit({
          userId: this.$route.params.id,
          ...(!this.bettingLimits.daily.isNoLimit && {
            amount: Number(this.bettingLimits.daily.amount),
          }),
          period: this.bettingLimits.daily.period,
          status: this.bettingLimits.daily.isNoLimit ? "inactive" : "active",
        }),
        this.setBetLimit({
          userId: this.$route.params.id,
          ...(!this.bettingLimits.weekly.isNoLimit && {
            amount: Number(this.bettingLimits.weekly.amount),
          }),
          period: this.bettingLimits.weekly.period,
          status: this.bettingLimits.weekly.isNoLimit ? "inactive" : "active",
        }),
        this.setBetLimit({
          userId: this.$route.params.id,
          ...(!this.bettingLimits.fortnightly.isNoLimit && {
            amount: Number(this.bettingLimits.fortnightly.amount),
          }),
          period: this.bettingLimits.fortnightly.period,
          status: this.bettingLimits.fortnightly.isNoLimit
            ? "inactive"
            : "active",
        }),
        this.setBetLimit({
          userId: this.$route.params.id,
          ...(!this.bettingLimits.monthly.isNoLimit && {
            amount: Number(this.bettingLimits.monthly.amount),
          }),
          period: this.bettingLimits.monthly.period,
          status: this.bettingLimits.monthly.isNoLimit ? "inactive" : "active",
        }),
      ]);
      if (res) {
        this.showToastSuccess("Success", `Set new betting limit successfully`);
        this.asyncUser({ id: this.$route.params.id });
      }
      return res;
    },
    convertBetLimit() {
      const limits = this.userData.betLimits || [];
      const dailyLimit = limits.find((l) => l.period === 1);
      const weeklyLimit = limits.find((l) => l.period === 7);
      const fortnightlyLimit = limits.find((l) => l.period === 14);
      const monthlyLimit = limits.find((l) => l.period === 30);
      if (!dailyLimit) this.bettingLimits.daily.isNoLimit = true;
      else {
        this.bettingLimits.daily.isNoLimit = false;
        this.bettingLimits.daily.amount = dailyLimit.amount;
      }
      if (!weeklyLimit) this.bettingLimits.weekly.isNoLimit = true;
      else {
        this.bettingLimits.weekly.isNoLimit = false;
        this.bettingLimits.weekly.amount = weeklyLimit.amount;
      }
      if (!fortnightlyLimit) this.bettingLimits.fortnightly.isNoLimit = true;
      else {
        this.bettingLimits.fortnightly.isNoLimit = false;
        this.bettingLimits.fortnightly.amount = fortnightlyLimit.amount;
      }
      if (!monthlyLimit) this.bettingLimits.monthly.isNoLimit = true;
      else {
        this.bettingLimits.monthly.isNoLimit = false;
        this.bettingLimits.monthly.amount = monthlyLimit.amount;
      }
    },
    handleResetLimit() {
      this.convertBetLimit();
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      formatCurrencyBuiltInFunc,
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.table-custom {
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.btn-set {
  width: 86px;
  height: fit-content;
}
.text-black {
  color: #000;
}

.dark-layout
  .flatpickr-calendar
  .flatpickr-days
  .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(
    .endRange
  ) {
  background: #ccc;
}
</style>
